import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { signOut } from "../../redux/actions/users";
import { formatBalance } from "../../helpers/functions";

const UserMenu = ({ user, onNavigate, signOut }) => {
    const { t, i18n } = useTranslation();
    const history = useHistory();

    const go = (path) => {
        if (onNavigate) onNavigate();
        history.push(path);
    };

    const doSignOut = () => {
        if (onNavigate) onNavigate();
        signOut();
    };

    const isLangActive = (lang) => i18n.language?.startsWith(lang);

    return (
        <div className="rev-usermenu">
            <span className="rev-usermenu__section">{t('account.basicData.lang.label')}</span>
            <button type="button" className="rev-usermenu__item" onClick={() => i18n.changeLanguage('es')}>
                <span>Español</span>
                {isLangActive('es') && <span className="rev-usermenu__right">{t('Active')}</span>}
            </button>
            <button type="button" className="rev-usermenu__item" onClick={() => i18n.changeLanguage('en')}>
                <span>English</span>
                {isLangActive('en') && <span className="rev-usermenu__right">{t('Active')}</span>}
            </button>
            <span className="rev-usermenu__sep" />
            <button type="button" className="rev-usermenu__item" onClick={() => go('/account/credit/home')}>
                <span>{t('account.sideNavigation.credit')}</span>
                <span className="rev-usermenu__right rev-num">{formatBalance(user?.balance, i18n.language)}</span>
            </button>
            <button type="button" className="rev-usermenu__item" onClick={() => go('/account/basic/home')}>
                {t('nav.menu.account')}
            </button>
            <a
                className="rev-usermenu__item"
                target="_blank"
                rel="noopener noreferrer"
                href="https://revopic.com/help"
                onClick={() => { if (onNavigate) onNavigate(); }}
            >
                {t('nav.menu.help')}
            </a>
            <span className="rev-usermenu__sep" />
            <button type="button" className="rev-usermenu__item rev-usermenu__item--danger" onClick={doSignOut}>
                {t('nav.menu.signOut')}
            </button>
        </div>
    );
};

const mapDispatchToProps = {
    signOut
};

export default connect(null, mapDispatchToProps)(UserMenu);
